import { useAuth } from "../contexts/AuthContext";
import { FlagKey, isFlagEnabled } from "../lib/featureFlags";

// Reads one feature flag for the current user.
export function useFlag(key: FlagKey): boolean {
  const { user } = useAuth();
  return isFlagEnabled(user, key);
}
